<template>
    <div>
        <span>{{ message }}</span>
    </div>
</template>

<script>
export default {
    name: "TableDataDownloaded",
    props: {
        activity: {
            type: Object,
            required: true
        }
    },
    computed: {
        message() {
            return this.$t('notification.tableDataDownloaded', {
                actor: this.$_.get(this.activity, 'actorUser.name'),
                tableName: this.$_.get(this.activity, 'payload.tableName'),
                recordCount: this.$_.get(this.activity, 'payload.recordCount', 0)
            });
        }
    }
};
</script>

